module.exports = __webpack_public_path__ + "static/media/IconTemplates_-34.e817e919.svg";